import { useState, useEffect } from 'react';
import { useLoadDrillTo } from 'scenes/Trackers/HourlyTracker/data';
import { useScreenState } from '@gogame/screens';

export const useNextLevel = () => {
  const { drillPath } = useScreenState();
  const [nextLevel, setNextLevel] = useState('');
  const { data: drillTo } = useLoadDrillTo({ drillPath });
  useEffect(() => {
    if (drillTo.length) {
      setNextLevel(drillTo[0].id);
    } else {
      setNextLevel('');
    }
  }, [drillTo]);

  return [nextLevel, setNextLevel];
};
